import { Exclude, Expose, Type } from 'class-transformer';

class Authority {
    authority: string;
}

export class Token {
    @Expose()
    token: string;
}
